import React from "react"
import { Grid } from "@mui/material"
import TCCalendar from "./TopCourtComponents/TCCalendar"
import { TCLabel } from "./TopCourtComponents/Label/TopCourtLabel"

function CalendarComponent ({
    userId
}) {
    return (
        <Grid container xs={12} p={2}>
            <div style={{height: 8, width: '100%'}}/>
            <TCCalendar data={[]} viewOnly={true} onChangeForm={(e) => {}} userId={userId} />
        </Grid>
    )
}

export default CalendarComponent